var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"multiple-choice-selector gl-border gl-block gl-rounded-base"},[_c('gl-form-checkbox-group',{attrs:{"checked":_vm.checked},on:{"input":function($event){return _vm.$emit('input', $event)}},scopedSlots:_vm._u([(_vm.glSlots().default)?{key:"default",fn:function(){return [_vm._t("default")]},proxy:true}:null],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }